// @mui
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
// hooks
import { useTranslation } from "../../../fe-ui/hooks/use-translation";

import hero from "./hero.jpg";
import overlay from "./overlay_1.svg";
import { fixAssetPath } from "../../../fe-ui/utils/fixAssetPath";
// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundImage: `url(${fixAssetPath(overlay.src)}), url(${fixAssetPath(hero.src)})`,
  padding: theme.spacing(10, 0),
  [theme.breakpoints.up("md")]: {
    height: 560,
    width: "100%",
    padding: 0
  }
}));

const StyledContent = styled("div")(({ theme }) => ({
  textAlign: "center",
  padding: "20px",
  color: theme.palette.common.white,
  [theme.breakpoints.up("md")]: {
    left: 80,
    bottom: 80,
    width: "80%",
    padding: 0,
    textAlign: "left",
    position: "absolute"
  }
}));

export function AboutHero() {
  const t = useTranslation();

  return (
    <StyledRoot>
      <StyledContent>
        <Typography variant="h2" sx={{ marginBottom: 6, color: "primary.main" }}>
          {t("Info_seaya_help")}
        </Typography>
        <Typography variant="h6">{t("Info_seaya_official_owner")}</Typography>
      </StyledContent>
    </StyledRoot>
  );
}
